import { render } from "./FaceCheck.vue?vue&type=template&id=5c129697&scoped=true"
import script from "./FaceCheck.vue?vue&type=script&lang=js"
export * from "./FaceCheck.vue?vue&type=script&lang=js"

import "./FaceCheck.vue?vue&type=style&index=0&id=5c129697&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/FaceChecker/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c129697"]])

export default __exports__